import { render, staticRenderFns } from "./removebutton.vue?vue&type=template&id=01200ffe&scoped=true&"
import script from "./removebutton.vue?vue&type=script&lang=js&"
export * from "./removebutton.vue?vue&type=script&lang=js&"
import style0 from "./removebutton.vue?vue&type=style&index=0&id=01200ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01200ffe",
  null
  
)

export default component.exports